import { useUser } from "@/contexts/user";
import { useIsStaff } from "./useIsStaff";
import { useGetOrganisations } from "@/api/lookup-http-functions";
import { hasPermission } from "@/utils/user-permission";
/**
 * IL-3127: Check feature flags, permissions, and Organisation.ExternalMaintenanceTicketingName
 * to determine if the user can view and create maintenance tickets.
 *
 * When the ExternalMaintenanceTicketingName is null, the maintenance ticket list and
 * 'report fault' button will be disabled for users of that org, even if feature flag is on & they have permission.
 * Report Fault will *not* be disabled for JC staff viewing devices in that org.
 */
export const useIsTicketingEnabled = () => {
    const { user } = useUser();
    const isStaff = useIsStaff();
    const { data: { organisations: allOrganisations } = {} } =
        useGetOrganisations({ query: { enabled: !isStaff } });
    const hasTicketingName =
        isStaff ||
        !!allOrganisations?.find(
            (org) => org.organisationId === user?.organisationId,
        )?.externalMaintenanceTicketingName;
    const canViewTickets =
        hasTicketingName && hasPermission(user, "ticketing_read");
    const canCreateTickets =
        hasTicketingName && hasPermission(user, "ticketing_create");
    return { canViewTickets, canCreateTickets };
};
